import { Injectable } from '@angular/core';
import {
  Router, Resolve, ActivatedRouteSnapshot
}                                 from '@angular/router';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take }         from 'rxjs/operators';
import { NeproseService } from '../services/neprose.service';

@Injectable({
  providedIn: 'root'
})
export class AdResolverService implements Resolve<any>{

  constructor( private neproseService: NeproseService, private router: Router) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Observable<never>{
    return this.neproseService.getAdvertisement(route.paramMap.get('id')).pipe(
      take(1),
      mergeMap(propertyAd=> {
        if (propertyAd) {
          if(propertyAd.propertyAd){
            return of(propertyAd);
          }else{
            this.router.navigate(['404']);
          }
        } else {
          this.router.navigate(['404']);
        }
      })
    )
  }
}